import { CustomText } from '@white-label-types/parking-shared'
import { getAppVariable } from '@white-label-helper/get-app-variable'
import defaultAxios from 'axios'

export enum MarketingChannels {
  sms = 'SMS',
  email = 'EMAIL',
}

type MarketingResponse = {
  marketing_channels: MarketingChannels[]
  strategy: 'opt-in' | 'opt-out'
  custom_text: CustomText
}

export const getMarketingSettings = async (): Promise<MarketingResponse> => {
  try {
    // Use base axios config with no auth to avoid CORS errors on public endpoint.
    const response = await defaultAxios({
      method: 'GET',
      baseURL: process.env['NUXT_ENV_PARTNER_CLOUDFRONT_URL'],
      // Having to put a time stamp on URL to break browser catch. Cache control headers not working
      url: `/amplify/${getAppVariable('channel.token')}.json?timeStamp=${Date.now().toString()}`,
    })
    return response.data.marketing_preferences;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  } catch (e: any) {
    throw new Error(e);
  }
}
